import { gql } from 'apollo-boost';

export const kyuRanksQuery = gql`
  query {
    kyuRanks {
      id
      name
    }
  }
`;

export const danRanksQuery = gql`
  query {
    danRanks {
      id
      name
    }
  }
`;

export const ranksQuery = gql`
  query {
    ranks {
      id
      name
    }
  }
`;

export const sectionsQuery = gql`
  query {
    sections {
      id
      name
    }
  }
`;

const COMMON = {
  kyuQuery: kyuRanksQuery,
  danQuery: danRanksQuery,
  sectionsQuery,
  ranksQuery,
};

export default COMMON;
